import React, { useEffect, useState } from 'react';
import { AppstoreOutlined, MailOutlined, SettingOutlined, SearchOutlined } from '@ant-design/icons';
import { MenuProps, Spin, Typography, Input } from 'antd';
import { Menu } from 'antd';

import Data from '../Data/Data.json'

import MyMenu from '../Models/Menu';

import CustumMenu from '../Models/CustumMenu';

import { useAuthHeader, useAuthUser, useSession, useSignOut } from '../Services/Auth/sessionAuth';

import Menus from '../Models/Menu';

import { useNavigate } from 'react-router-dom';

import axios from 'axios';

import Utilisateur from '../Models/Utilisateur';

import { Crypter } from '../Functions/Security/Crypter';

import { Collapse, Skeleton } from '@mui/material';

import { Box } from '@mui/system';

import GetCookie from './Hooks/Cookies/GetCookie';

import NotFound from './NotFound';

import SweetAlert from "sweetalert2"

import UpdatePassword from './Forms/UpdatePassword';

import { ArrowForwardIos, CircleOutlined, CircleSharp, Google, PointOfSale } from '@mui/icons-material';

import { icons } from 'antd/es/image/PreviewGroup';

import GetBackground from '../Functions/GetBackground';

import Agence from '../Models/Agence';

import ReformatDate from '../Functions/Traitement/ReformatDate';

import formatDate from '../Functions/Traitement/fomatDate';

import formatOrderDate from '../Functions/Traitement/formatOrderDate';

import { MENU_FOCUS_EVENT, MenuFocusDetail, getMenuAncestorKeys } from '../Functions/MenuFocus';



type MenuItem = Required<MenuProps>['items'][number];



function getItem(

  label: React.ReactNode,

  key?: React.Key | null,

  icon?: React.ReactNode,

  children?: MenuItem[],

  type?: 'group',

): MenuItem {

  return {

    key,

    icon,

    children,

    label,

    type,

  } as MenuItem;

}



// const items: MenuItem[] = [

//   getItem('Navigation One', 'sub1', <MailOutlined />, [

//     getItem('Item 1', null, null, [getItem('Option 1', '1'), getItem('Option 2', '2')], 'group'),

//     getItem('Item 2', null, null, [getItem('Option 3', '3'), getItem('Option 4', '4')], 'group'),

//   ]),



//   getItem('Navigation Two', 'sub2', <AppstoreOutlined />, [

//     getItem('Option 5', '5'),

//     getItem('Option 6', '6'),

//     getItem('Submenu', 'sub3', null, [getItem('Option 7', '7'), getItem('Option 8', '8')]),

//   ]),



//   getItem('Navigation Three', 'sub4', <SettingOutlined />, [

//     getItem('Option 9', '9'),

//     getItem('Option 10', '10'),

//     getItem('Option 11', '11'),

//     getItem('Option 12', '12'),

//   ]),

// ];





const Habilitation: React.FC = () => {



  // USER SESSION

  const auth = useAuthUser()

  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))

  const signOut = useSignOut()



  // USER TOKEN

  const authHeader = useAuthHeader()



  const [menus, setMenus] = useState<Menus[]>([]);

  // const [branchs, setBranchs] = useState<Agence[]>([]);

  const navigate = useNavigate()

  const [load, setLoad] = useState(true);

  const [isOk, setIsOk] = useState(false);

  const [updatepass, setUpdatepass] = useState(false);

  const [loading, setLoading] = useState(false);

  const { signIn } = useSession()



  useEffect(() => {

    let mounted = true;



    setLoad(true);

    let data = Crypter.encrypt(user.codgroup);

    console.info('[MENU DEBUG] Habilitation request start', {

      userCode: user.coduti ?? null,

      groupCode: user.codgroup ?? null,

      endpoint: Data.ApiUrl.userMenus,

    });

    const config = {

      method: 'get',

      maxBodyLength: Infinity,

      url: Data.ApiUrl.userMenus,

      headers: {

        'Authorization': authHeader(),

        'Content-Type': 'application/json',

        'CipherUserGroup': data

      }

    };



    axios.request(config)

      .then((response) => {

        console.info('[MENU DEBUG] Habilitation response', {

          httpStatus: response.status,

          hasResponseData: Boolean(response.data),

        });

        if (!mounted || !response.data) return;



        const res = JSON.parse(Crypter.decrypt(response.data)).Value;

        console.info('[MENU DEBUG] Habilitation business result', {

          status: res?.StatutCode ?? null,

          menuCount: Array.isArray(res?.Result) ? res.Result.length : null,

        });

        if (res.StatutCode == 200) {

          setMenus(Array.isArray(res.Result) ? res.Result : []);

          setIsOk(true);

        } else {

          setMenus([]);

          setIsOk(false);

        }

      })

      .catch((error) => {

        console.error('[MENU DEBUG] Habilitation request failed', {

          httpStatus: error?.response?.status ?? null,

          message: error?.message ?? 'unknown error',

        });

        if (mounted) {

          setMenus([]);

          setIsOk(false);

        }

      })

      .finally(() => {

        if (mounted) setLoad(false);

      });



    return () => {

      mounted = false;

    };

  }, [user.codgroup, authHeader]);





  function loadMenu(codgroup : string) {

    setLoad(true)

    let data = Crypter.encrypt(codgroup);

    //console.log(data)



    let config = {

      method: 'get',

      maxBodyLength: Infinity,

      url: Data.ApiUrl.userMenus,

      headers: {

        'Authorization': authHeader(),

        'Content-Type': 'application/json',

        "CipherUserGroup": data

      }

    };



    axios

      .request(config)

      .then((response) => {

        if (response.data) {

          const res = JSON.parse(Crypter.decrypt(response.data)).Value;

          // console.log(res)

          if (res.StatutCode == 200) {

            setMenus(res.Result)

            setIsOk(true)



            // sessionStorage.setItem("menu", Crypter.encrypt(JSON.stringify(res.Result)))

          }

          else {

            setIsOk(false)

            // Error message

          }



        }

      })

      .catch((error) => {

        setIsOk(false)

        // console.log(error);

      }).finally(() => {

        setLoad(false)

      })

  }

  function loadBranchs(coduti : string) {

    setLoading(true)

    let data = Crypter.encrypt(coduti);



    let config = {

      method: 'get',

      maxBodyLength: Infinity,

      url: Data.ApiUrl.GetUserBranchs,

      headers: {

        'Authorization': authHeader(),

        'Content-Type': 'application/json',

        "CypherUser": data

      }

    };



    axios

      .request(config)

      .then((response) => {

        setLoading(false)

        if (response.data) {

          const res = JSON.parse(Crypter.decrypt(response.data)).Value;

          if (res.StatutCode == 200) {



            if (res.Result.length == 1) {

              SweetAlert.fire({ title: "Vous n'êtes habilité que à une seule agence!", text: 'Agence : ' + user.codage + ' - ' + user.agence, icon: "warning" })

            }

            else {



              var ags: { [name: string]: string } = {};

              res.Result.map((u: any) => {

                if (u.CodeAgence.split('|')[0] != user.codage) {

                  ags[u.CodeAgence] = u.CodeAgence.split('|')[0]+' - '+u.Libelle

                }

              })

              SweetAlert.fire({

                title: "Changement d'agence",

                text: "Agence actuel : " + user.codage + ' - ' + user.agence,

                showCancelButton: true,

                color: "#116599",

                cancelButtonText: "Anuller",

                confirmButtonText: "Changer",

                confirmButtonColor: "#116599",

                cancelButtonColor: "darkred",

                showLoaderOnConfirm: true,

                input: 'select',

                inputOptions: ags,

                inputPlaceholder: "Sélectionner l'agence de connexion",

                icon: 'warning'

              }).then((resp) => {



                if (resp.isConfirmed) {

                  if (resp.value != null && resp.value != "") {

                    if (resp.value == user.codage) {

                      SweetAlert.fire({ title: "Vous êtes déjà dans cette agence!", icon: "warning" })

                    } else {

                      // Changement d'agence

                      var datejour = formatOrderDate(resp.value.split('|')[4].split(' ')[0]);

                        if (signIn({ authState: { "coduti": user.coduti, "nomuti": user.nomuti, "codage": resp.value.split('|')[0], "agence": resp.value.split('|')[1], "codgroup": resp.value.split('|')[2], "group": resp.value.split('|')[3], "datjour": datejour } })) {

                      loadMenu(resp.value.split('|')[2])

                      navigate("/")

                      // window.location.reload()

                    }



                    }

                  }

                  else {

                    SweetAlert.fire({ title: "Aucune agence n'a été sélectionné!", icon: "warning" })

                  }

                }

              }).catch((error) => {

                setLoading(false);

                // console.log(error)

                SweetAlert.fire({ title: error, icon: "error" })

              })

            }





          }



        }

      })

      .catch((error) => {

        setLoading(false)

      })

  }





  // console.log(CustumMenu.getMenu(menus))

  const onClick: MenuProps['onClick'] = (e) => {

    let lien = (menus.find((menu: Menus) => menu.codmen == e.key)?.lien)

    //console.log('click', e);



    setCurrent(e.key);

    setSelectedKeys([e.key]);



    if (e.key == "F02") {

      SweetAlert.fire({

        title: "Déconnexion",

        text: "Voulez-vous vraiment vous déconnecter ?",

        showCancelButton: true,

        color: "#116599",

        confirmButtonText: "Yes",

        confirmButtonColor: "#116599",

        cancelButtonColor: "darkred",

        cancelButtonText: "No",

        showLoaderOnConfirm: true,

        icon: 'question'

      }).then((res) => {

        if (res.isConfirmed) {



          //SweetAlert.showLoading()

          setLoading(true)



          let config = {

            method: 'post',

            maxBodyLength: Infinity,

            url: 'https://csal.f2itech.tech:450/Authentification/logout',

            withCredentials: true,

            headers: {

              'Content-Type': 'application/json',

            },

            //data: data

          };



          axios.request(config)

            .then((response) => {

              signOut()

              let res = JSON.parse(Crypter.decrypt(response.data))

              //console.log(res);



              setLoading(false)

            })

            .catch((error) => {

              setLoading(false)

              SweetAlert.fire({

                title: "Déconnexion",

                text: error.message + "",

                icon: 'error',

                cancelButtonColor: "darkred",

                cancelButtonText: "Cloase",

              })

            });

        }

      }).catch(() => {



      })

    }

    else if (e.key == "F03") {

      setUpdatepass(true)

    }

    else if (e.key == "F04") {

      loadBranchs(user.coduti)

    }

    else if (e.key == 'MFA_CONFIG') {

      navigate('/mfa/configuration')

    }

    else if (e.key == 'AGENCE_CRUD') {

      navigate('/systeme/agence')

    }

    else if(lien?.includes("statistics")){

      window.open("https://csal.f2itech.tech:450/Reports/", "_blank", "noopener,noreferrer");

    }



    else {

      if (lien != null) navigate(lien)



    }

    //console.log((menus.find((menu : Menus)=>menu.codmen == e.key)?.lien))



  };



  const [current, setCurrent] = useState('mail');

  const [selectedKeys, setSelectedKeys] = useState<string[]>([]);

  const [openKeys, setOpenKeys] = useState<string[]>(['sub1']);

  // Mise en évidence d'une entrée demandée depuis la recherche de l'Appbar
  useEffect(() => {
    let scrollTimer = 0;

    const handleFocusRequest = (event: Event) => {
      const codmen = (event as CustomEvent<MenuFocusDetail>).detail?.codmen;
      if (!codmen) return;

      setOpenKeys((previous) => Array.from(new Set([...previous, ...getMenuAncestorKeys(codmen)])));
      setSelectedKeys([codmen]);

      // Laisse le temps aux sous-menus de s'ouvrir avant de faire défiler
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(() => {
        document
          .querySelector(`.menu [data-menu-id$="-${codmen}"]`)
          ?.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }, 300);
    };

    window.addEventListener(MENU_FOCUS_EVENT, handleFocusRequest);
    return () => {
      window.clearTimeout(scrollTimer);
      window.removeEventListener(MENU_FOCUS_EVENT, handleFocusRequest);
    };
  }, []);

  const filterMenuItems = (items: MenuItem[], search: string): MenuItem[] => {
    if (!search) return items;
    
    const lowerSearch = search.toLowerCase();
    
    return items.reduce((filtered: MenuItem[], item) => {
      if (!item) return filtered;
      
      // Vérifier si l'item a une propriété label
      const hasLabel = 'label' in item && item.label !== undefined;
      const label = hasLabel ? String(item.label).toLowerCase() : '';
      const hasMatch = label.includes(lowerSearch);
      
      if ('children' in item && item.children) {
        const filteredChildren = filterMenuItems(item.children, search);
        if (filteredChildren.length > 0 || hasMatch) {
          filtered.push({
            ...item,
            children: filteredChildren
          } as MenuItem);
        }
      } else if (hasMatch && hasLabel) {
        filtered.push(item);
      }
      
      return filtered;
    }, []);
  };

  return (

    <Box className='nav'>

      <Spin spinning={loading} size='large' style={{ color: '#116599' }} >



        {load ?

          <Box className='LoadMenus'>

            <Skeleton variant='rectangular' height={30} /><br />

            <Skeleton variant='rectangular' height={30} /><br />

            <Skeleton variant='rectangular' height={30} /><br />

            <Skeleton variant='rectangular' height={30} /><br />

            <Skeleton variant='rectangular' height={30} /><br />

            <Skeleton variant='rectangular' height={30} /><br />

            <Skeleton variant='rectangular' height={30} /><br />

            <Skeleton variant='rectangular' height={30} /><br />

            <Skeleton variant='rectangular' height={30} /><br />

            <Skeleton variant='rectangular' height={30} /><br />

          </Box>

          :

          isOk ?

            <Menu

              itemIcon={<ArrowForwardIos fontSize='inherit' color='disabled' />}

              className='menu'

              onClick={onClick}

              style={{ width: 256, backgroundColor: GetBackground() }}

              selectedKeys={selectedKeys}

              openKeys={openKeys}

              onOpenChange={(keys) => setOpenKeys(keys as string[])}

              mode="inline"

              theme={GetCookie(Data.LocalVariable.mode)}

              items={[...CustumMenu.getMenu(menus)] as MenuItem[]}

            />

            :

            <><br /><br />

              <NotFound width={250} /><br />

              <center><Typography >Modules Not Found</Typography></center>

            </>

        }

        {updatepass ? <UpdatePassword f={()=>{setUpdatepass(!updatepass)}} name={user.coduti+'-'+user.nomuti} /> : ''}

        {/* <Collapse in= {updatepass} >

        <UpdatePassword name={user.nomuti} />

      </Collapse> */}

      </Spin>

    </Box>

    // <Menu onClick={onClick} style={{ width: 256 }} mode="inline" selectedKeys={[current]} items={CustumMenu.getMenu(menus)} />

  );

}



export default Habilitation;